export default __webpack_public_path__ + "static/quick-swap-8a1b4ba2e76a075e0cd42c5427a2613c.png";